import { STUDIO } from "@/config";

const links = [
  { href: "#specs", label: "The Space", id: "the-space" },
  { href: "#amenities", label: "Amenities", id: "amenities" },
  { href: "#backdrops", label: "Backdrops", id: "backdrops" },
  { href: "#inventory", label: "Props", id: "props" },
  { href: "#plans", label: "Packages", id: "packages" },
  { href: "#promo", label: "Discount Voucher", id: "voucher" },
  { href: "#studio-map", label: "Location", id: "location" },
];

export const Navbar = () => (
  <header
    data-testid="site-navbar"
    className="sticky top-0 z-40 bg-bg/90 backdrop-blur-md border-b border-line"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between gap-4">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
        <img
          src={STUDIO.logo}
          alt="Room 9 logo"
          data-testid="nav-logo-image"
          className="w-10 h-10 object-contain"
        />
        <span
          data-testid="nav-logo-name"
          className="font-extrabold text-ink tracking-tight text-lg leading-none"
        >
          {STUDIO.name}
        </span>
      </a>
      <nav className="hidden lg:flex items-center gap-8 label-caps text-muted-g">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`nav-link-${l.id}`}
            className="hover:text-forest transition-colors"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <a href="#contact" data-testid="nav-book-button" className="btn-primary !px-4 !py-2">
        Book Studio
      </a>
    </div>
  </header>
);
